export const TEMPERAMENT_POOL: string[] = [
	"hot-headed",
	"taciturn",
	"meticulous",
	"erratic",
	"melancholic",
	"glib",
	"pedantic",
	"effusive",
	"sardonic",
	"mercurial",
	"diffident",
	"zealous",
	"verbose",
	"sweet",
	"anxious",
	"haughty",
	"sly",
	"theatrical",
	"aloof",
	"cheery",
	"mischievous",
	"stoic",
	"curious",
	"earnest",
];
